<template>
  <div class="myaccount">
    <CommonHead></CommonHead>
    <!-- <WelcomeGuest :breadcrumbs="breadcrumb" generateLeadButton="false"></WelcomeGuest> -->
    <div class="accountdetails">
      <sidebar></sidebar>
      <div class="inneraccount">
        <h1 class="account-mobile">Account</h1>
        <div class="accountboxes">
          <div class="boxgrid">
            <h4>Personal Information</h4>
            <div class="personaldetails">
              <div class="samediv">
                <span>Name:</span>
                <p>{{user.firstname | capitalize}} {{user.lastname | capitalize}}</p>
              </div>
              <div class="samediv">
                <span>Email:</span>
                <p>{{user.email}}</p>
              </div>
              <div class="samediv">
                <span>Company:</span>
                <p>{{info.NAME}}</p>
              </div>
              <div class="samediv">
                <span>Account Number:</span>
                <p>{{info.ACCOUNTNUM}}</p>
              </div>
              <div class="samediv">
                <span>Purchases:</span>
                <p>
                  Month to date: $ {{info.MonthToDate?info.MonthToDate:'0.00'}}
                  <br />Year to date: $ {{info.YearToDate?info.YearToDate:'0.00'}}
                </p>
              </div>
            </div>
          </div>
          <div class="boxgrid">
            <h4>Change Password</h4>
            <b-form class="commonform" @submit="onSubmit">
              <b-row>
                <b-col>
                  <md-field :class="resetform.errors.get('old_password')?'haserror':''" :state="!resetform.errors.has('old_password')"
                                        :invalid-feedback="resetform.errors.get('old_password')">
                    <label>Current Password</label>
                    <md-input id="old_password"
                      type="password"
                      v-model="resetform.old_password"
                      :state="!resetform.errors.has('old_password')"></md-input>
                    <span class="error-msg" v-if="resetform.errors.get('old_password')">{{resetform.errors.get('old_password')}}</span>
                  </md-field>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <md-field :class="resetform.errors.get('password')?'haserror':''" :state="!resetform.errors.has('password')"
                                        :invalid-feedback="resetform.errors.get('password')">
                    <label>New Password</label>
                    <md-input id="password" type="password" v-model="resetform.password"
                        :state="!resetform.errors.has('password')"></md-input>
                  <span class="error-msg" v-if="resetform.errors.get('password')">{{resetform.errors.get('password')}}</span>                  
                  </md-field>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <md-field :class="resetform.errors.get('confirm_password')?'haserror':''" :state="!resetform.errors.has('confirm_password')"
                                        :invalid-feedback="resetform.errors.get('confirm_password')">
                    <label>Confirm New Password</label>
                    <md-input id="confirm_password" type="password"
                        v-model="resetform.confirm_password"
                        :state="!resetform.errors.has('confirm_password')"></md-input>
                    <span class="error-msg" v-if="resetform.errors.get('confirm_password')">{{resetform.errors.get('confirm_password')}}</span>
                  </md-field>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-button type="submit" variant="dark" squared>Save</b-button>
                </b-col>
                <b-col>
                  <b-button type="reset" class="float-right" variant="outline-primary" squared>Cancel</b-button>
                </b-col>
              </b-row>
            </b-form>
          </div>
          <div class="boxgrid">
            <h4>Addresses</h4>
            <span>Default Billing Address</span>
            <p>
              {{info.address.STREET?info.address.STREET:''}}<br/>
              {{info.address.CITY?info.address.CITY+', ':''}}
              {{info.address.STATE?info.address.STATE:''}}
              {{info.address.ZIPCODE?info.address.ZIPCODE:''}}<br/>
              {{info.address.COUNTRYREGIONID?info.address.COUNTRYREGIONID:''}}
            </p>
            <span>Default Shipping Address</span>
            <p>
              {{info.Street?info.Street:''}}<br/>
              {{info.CITY?info.CITY+', ':''}}
              {{info.STATE?info.STATE:''}}
              {{info.ZIPCODE?info.ZIPCODE:''}}<br/>
              {{info.COUNTRYREGIONID?info.COUNTRYREGIONID:''}}
            </p>
          </div>
          <div class="boxgrid">
            <h4>Payment Due</h4>
            <div class="samediv">
              <span>Current -</span>
              <p>$  {{info.DueToday?info.DueToday:'0.00'}}</p>
            </div>
            <div class="samediv">
              <span>30 Days -</span>
              <p>$  {{info.Days37?info.Days37:'0.00'}}</p>
            </div>
            <div class="samediv">
              <span>60 Days -</span>
              <p>$  {{info.Days60?info.Days60:'0.00'}}</p>
            </div>
            <div class="samediv">
              <span>90 Days -</span>
              <p>$  {{info.Days90?info.Days90:'0.00'}}</p>
            </div>
            <div class="samediv">
              <span>120 Days -</span>
              <p>$  {{info.Days120?info.Days120:'0.00'}}</p>
            </div>
            <div class="samediv">
              <span>Over 120 Days -</span>
              <p>$  {{info.DaysOver120?info.DaysOver120:'0.00'}}</p>
            </div>
            <div class="amountdue">
              <div class="samediv">
                <span>Amout Due:</span>
                <p>$  {{info.amount_due}}</p>
              </div>
              <b-button variant="dark" squared v-on:click="goto">Payment Due</b-button>
            </div>
          </div>
          <div class="boxgrid">
            <h4>Manage Preferences</h4>
            <b-row>
              <b-col>
                <md-checkbox @change="ChangeSettings()" v-model="settingform.pricemode" id="showwholesale">Show Retail Price Only</md-checkbox>
              </b-col>
            </b-row>
          </div>
        </div>
        <div class="needhelp">
          <h4>Need Help?</h4>
          <div class="callwrite">
            <div class="callus">
              <h5>Call Us</h5>
              <a>
                <b-img src="/shop/images/phone.svg"></b-img>800.325.8025 
              </a>
              <span>Mon - Fri 8:00 AM - 5:00 PM (CDT)</span>
            </div>
            <div class="writeus">
              <h5>Write to Us</h5>
              <a href="mailto:customerservice@rmcoco.com">
                <b-img src="/shop/images/mail.svg"></b-img>customerservice@rmcoco.com
              </a>
              <span>We’ll get back to you within 24 hours.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CommonFoot></CommonFoot>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Sidebar from "@/components/Sidebar";
import CommonHead from "@/components/CommonHead";
import CommonFoot from "@/components/CommonFoot";
import ResourceMixin from "../../mixins/resources";
//import WelcomeGuest from "@/components/WelcomeGuest";

export default {
  components: {
    Sidebar,
    CommonHead,
    CommonFoot
  },
  mixins: [ResourceMixin],
  mounted() {
      this.$store.dispatch("loadAccountInfo").then(accountinfo => {
          this.accountinfo = accountinfo.data;
          this.info.ACCOUNTNUM = this.accountinfo[0].ACCOUNTNUM;
          this.info.NAME = this.accountinfo[0].NAME;
          this.info.CITY = this.accountinfo[0].CITY;
          this.info.Street = this.accountinfo[0].Street;
          this.info.STATE = this.accountinfo[0].STATE;
          this.info.ZIPCODE = this.accountinfo[0].ZIPCODE;
          this.info.COUNTRYREGIONID = this.accountinfo[0].COUNTRYREGIONID;
          this.info.YearToDate = this.accountinfo[0].YearToDate;
          this.info.MonthToDate = this.accountinfo[0].MonthToDate;
          this.info.DueToday = this.accountinfo[0].DueToday;
          this.info.Days37 = this.accountinfo[0].Days37;
          this.info.Days60 = this.accountinfo[0].Days60;
          this.info.Days90 = this.accountinfo[0].Days90;
          this.info.Days120 = this.accountinfo[0].Days120;
          this.info.DaysOver120 = this.accountinfo[0].DaysOver120;
          this.info.amount_due = this.accountinfo[0].amount_due;
          this.info.address = this.accountinfo.address;
      });
      this.settingform.pricemode = this.user.setting_retail;
  },
  data() {
    return {
      resetform: new Form({
          old_password: null,
          password: null,
          confirm_password: null
      }),
      settingform: new Form({
        pricemode:false
      }),
      isLoading: false,
      accountinfo:[],
      info:{
        ACCOUNTNUM: null,
        NAME: null,
        CITY: null,
        Street: null,
        STATE: null,
        ZIPCODE: null,
        COUNTRYREGIONID: null,
        YearToDate: null,
        MonthToDate: null,
        DueToday: 0,
        Days37: 0,
        Days60: 0,
        Days90: 0,
        Days120: 0,
        DaysOver120: 0,
        amount_due: 0,
        address:[]
      },
      breadcrumb: [
        {
          text: "My Account",
          active: true
        }
      ]
    };
  },
  computed: {
        ...mapGetters(["user"])
    },
  methods: {
    goto(){
      this.$router.push('invoices');
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.updatePassword();
    },
    updatePassword() {
     this.isLoading = true;
      this.$store
          .dispatch("resetPassword", this.resetform)
          .then(response => {
              if (response.data.success) {
                  this.$notify({
                      text: response.data.message,
                      type: "success"
                  });
                  this.resetform = new Form({
                      old_password: null,
                      password: null,
                      confirm_password: null
                  });
              } else {
                  this.$notify({
                      text: response.data.message,
                      type: "error"
                  });
              }
          });
          this.isLoading = false;
    },
    ChangeSettings(){
      this.$store.dispatch("changeSettings", this.settingform).then(response => {
        if (response.data.success) {
          this.$notify({
              text: "Settings updated successfully.",
              type: "success"
          });
        }
      });
    }
  }
};
</script>
<style>
.account-mobile{
	display:none;
}
.accountdetails {
  width: 100%;
  position: relative;
  overflow: hidden;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: left;
  align-items: stretch;
}
.accountdetails .inneraccount {
  width: 100%;
  margin-left: 26.3%;
  min-height: 615px;
  max-width: 100%;
}
.accountdetails .inneraccount .accountboxes {
  display: flex;
  justify-content: left;
  flex-wrap: wrap;
  margin-top: 40px;
  padding-left: 40px;
  max-width: 1170px;
  width: 100%;
}
.accountdetails .boxgrid {
  width: 30.3%;
  padding: 20px 30px 30px 30px;
  box-sizing: border-box;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
  margin-right: 40px;
  margin-bottom: 40px;
  position: relative;
}
.accountdetails .accountboxes .boxgrid form.commonform {
  margin-top: -10px;
}
.accountdetails .inneraccount .accountboxes .boxgrid:nth-child(3),
.accountdetails .inneraccount .accountboxes .boxgrid:nth-child(5) {
  margin-right: 0;
}
.accountdetails .inneraccount .accountboxes .boxgrid:nth-child(4),
.accountdetails .inneraccount .accountboxes .boxgrid:nth-child(5) {
  width: 47.4%;
}
.accountdetails .inneraccount .accountboxes .boxgrid h4 {
  text-align: left;
  margin-bottom: 15px;
  width: 100%;
  font-size: 16px;
  display: inline-block;
}
.accountdetails .samediv {
  display: inline-block;
  width: 100%;
}
.accountdetails span,
.accountdetails .boxgrid p {
  color: #777777;
  font-size: 14px;
  float: left;
  line-height: 24px;
  margin-right: 10px;
}
.accountdetails .boxgrid p {
  color: #303030;
  margin: 0 0 10px 0;
  line-height: 24px;
}
#app .accountdetails .inneraccount .accountboxes .boxgrid .md-checkbox {
  margin-bottom: 25px;
}
.accountdetails .inneraccount .needhelp {
  background: #ececec;
  padding: 35px 35px 45px 35px;
  box-sizing: border-box;
  width: 75%;
  max-width: 610px;
  margin-left: 40px;
  margin-bottom: 80px;
}
.accountdetails .inneraccount .needhelp .callwrite {
  display: flex;
  justify-content: space-between;
}
.accountdetails .inneraccount .needhelp h4 {
  text-align: left;
  font-weight: 500;
  font-size: 16px;
}
.accountdetails .inneraccount .needhelp h5 {
  text-align: left;
  font-weight: 600;
  font-size: 14px;
  margin: 30px 0 8px 0;
}
.accountdetails .inneraccount .needhelp a {
  font-size: 14px;
  line-height: 20px;
  margin-top: 12px;
  text-decoration: none;
  color: #303030;
}
.accountdetails .inneraccount .needhelp a img {
  height: 16px;
  width: 16px;
  display: inline-block;
  margin: 0 10px 0 0;
}
.accountdetails .inneraccount .needhelp span {
  font-size: 12px;
  color: #777777;
  margin-top: 8px;
  display: inline-block;
}
#app .boxgrid .md-field {
  margin-bottom: 10px;
}
.accountdetails .inneraccount .accountboxes .boxgrid button.btn-dark {
  padding: 0.375rem 3.5rem;
}
.accountdetails
  .inneraccount
  .accountboxes
  .boxgrid
  button.btn-outline-primary {
  padding: 0.375rem 1.5rem;
}
.accountdetails .inneraccount .accountboxes .boxgrid .amountdue {
  width: 200px;
  position: absolute;
  right: 30px;
  bottom: 52px;
}
.accountdetails .inneraccount .accountboxes .boxgrid .amountdue .samediv span,
.accountdetails .inneraccount .accountboxes .boxgrid .amountdue .samediv p {
  font-size: 16px;
  color: #303030;
  font-weight: 500;
}
.accountdetails .inneraccount .accountboxes .boxgrid:nth-child(3) p {
  margin-bottom: 30px;
}
@media only screen and (min-width:1441px) and (max-width:1680px){
	.accountdetails .inneraccount{
		margin-left:26.3%;
	}
	.accountdetails .inneraccount .accountboxes{
		max-width:1120px;
	}
}
@media only screen and (max-width: 1500px) and (min-width: 1420px) {
  /* .accountdetails .inneraccount .accountboxes .boxgrid {
    flex-basis: 30.1%;
  } */
  .accountdetails .inneraccount .accountboxes .boxgrid button.btn-dark {
    padding: 0.375rem 2.5rem;
  }
  /*.accountdetails
    .inneraccount
    .accountboxes
    .boxgrid
    button.btn-outline-primary {
    padding: 0.375rem 2rem;
  }*/
}
@media only screen and (max-width: 1440px) {
  .accountdetails .inneraccount {
    margin-left: 26.9%;
  }
  .accountdetails .inneraccount .accountboxes{
    padding-right: 30px;
  }
  .accountdetails .inneraccount .accountboxes .boxgrid:nth-child(4),
  .accountdetails .inneraccount .accountboxes .boxgrid:nth-child(5) {
    flex-basis: inherit;
    flex-grow: inherit;
    width: 48.4%;
  }
  .accountdetails .boxgrid {
    padding: 20px;
    box-sizing: border-box;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
    width: 31.4%;
    margin-right: 25px;
    margin-bottom: 25px;
  }
  /* .accountdetails
    .inneraccount
    .accountboxes
    .boxgrid
    button.btn-outline-primary {
    padding: 0.375rem 1.9rem;
  } */
  .accountdetails .inneraccount .accountboxes .boxgrid button.btn-dark {
    padding: 0.375rem 3rem;
  }
  .accountdetails .inneraccount .needhelp {
    width: 65%;
  }
  .accountdetails .inneraccount .accountboxes .boxgrid .amountdue {
    width: 175px;
  }
}
@media only screen and (max-width: 1360px) {
  .accountdetails .inneraccount {
    margin-left: 350px;
  }
}
@media only screen and (max-width: 1320px) {
  .accountdetails .boxgrid {
    width: 31%;
  }
  .accountdetails .inneraccount .accountboxes .boxgrid:nth-child(4),
  .accountdetails .inneraccount .accountboxes .boxgrid:nth-child(5) {
    width: 48%;
  }
  .accountdetails .inneraccount .needhelp {
    margin-left: 20px;
  }
  .accountdetails .inneraccount .accountboxes {
    padding-left: 20px;
    padding-right: 10px;
  }
}
@media only screen and (max-width: 1199px) and (min-width: 1025px) {
  .accountdetails .boxgrid{
    width:47%;
  }
  .accountdetails .inneraccount .accountboxes .boxgrid:nth-child(2), .accountdetails .inneraccount .accountboxes .boxgrid:nth-child(4) {
      margin-right: 0;
  }
  .accountdetails .inneraccount .accountboxes .boxgrid:nth-child(3), .accountdetails .inneraccount .accountboxes .boxgrid:nth-child(5) {
      margin-right: 20px;
  }
  .accountdetails .inneraccount .needhelp {
      width: 87%;
  }
  .accountdetails .inneraccount .accountboxes .boxgrid .amountdue{
    position: relative;
    right: 0;
    bottom: auto;
  }
}
@media only screen and (max-width:1024px) and (min-width:768px){
	.accountdetails .inneraccount {
		margin-left: 270px;
	}
	.accountdetails .inneraccount .accountboxes{
		padding-right:30px;
	}
	.headwrap.positionfix + .accountdetails .sidebar, .headwrap.positionfix + .accountdetails.mainprojectsection .orderspage.projectspage .projectlistbar {
		top: 70px;
	  }
	.accountdetails .boxgrid{
		width: 100%;
		margin-right: 0;
		max-width: 450px;
	}
	.accountdetails .accountboxes .boxgrid > span{
		width:100%;
	}
	.accountdetails .inneraccount .accountboxes{
		justify-content:center;
	}
	.accountdetails .inneraccount .accountboxes .boxgrid:nth-child(4), .accountdetails .inneraccount .accountboxes .boxgrid:nth-child(5) {
		width: 100%;
	}
	.accountdetails .inneraccount .accountboxes .boxgrid .amountdue {
		width: 175px;
		position: relative;
		right: auto;
		bottom: auto;
	}
	.accountdetails .inneraccount .needhelp {
		margin-left: 20px;
		margin: 0 auto 40px auto;
		max-width: 450px;
		padding-left: 20px;
		padding-right: 20px;
		width:100%;
	}
	.accountdetails .inneraccount .needhelp a{
		width:100%;
		display:inline-block;
	}
	.accountdetails .inneraccount .needhelp .callwrite{
		flex-wrap:wrap;
	}
}
@media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2){
	.accountdetails .orderspage .orderdetails .card-header .card-header-tabs {
		-webkit-box-pack: space-between;
		justify-content: space-between;
	}
	.accountdetails .orderspage .orderdetails .card-header .nav-tabs .nav-item{
		width:auto;
	}
	.accountdetails .inneraccount .accountboxes {
		-webkit-box-pack: space-between;
		justify-content: space-between;
		padding-right:20px;
		padding-left:10px;
	}
	.accountdetails .boxgrid{
		max-width:350px;
	}
	.accountdetails .inneraccount .needhelp{
		margin: 0 0 40px 10px;
		max-width: 350px;
		padding-left: 20px;
		padding-right: 20px;
		width: 100%;
	}
}
@media only screen and (max-width:767px){
    .accountdetails{
        flex-wrap: wrap;
    }
    .sidebar {
        width: 100%;
        float: none;
        position: relative;
        height: auto;
        top:auto;
    }
    .headwrap.positionfix + .accountdetails .sidebar, .headwrap.positionfix + .accountdetails.mainprojectsection .orderspage.projectspage .projectlistbar{
      top:auto;
    }
	.accountdetails .inneraccount .accountboxes .boxgrid .amountdue{
		width: 100%;
		position: relative;
		right: auto;
		bottom: auto;
	}
    .profileset {
        width: 100%;
    }
    .sidebar .sidenavbar {
        max-width: 100%;
        float: none;
    }
    .accountdetails .inneraccount {
        margin-left: 0;
    }
    .accountdetails .inneraccount{
        padding-left: 20px;
        padding-right: 20px;
    }
	.accountdetails .inneraccount .accountboxes{
		padding:0;
	}
    .accountdetails .boxgrid {
      width: 100%;
      margin-right:0;
    }
    .accountdetails .inneraccount .accountboxes .boxgrid:nth-child(4), .accountdetails .inneraccount .accountboxes .boxgrid:nth-child(5) {
      width: 100%;
      margin-right: 0;
    }
    .accountdetails .inneraccount .needhelp {
      margin: 0 auto 20px auto;
      max-width: 100%;
      padding: 35px 15px 45px 15px;
      margin:0 auto 50px auto;
      width: 100%;
    }
	.accountdetails .inneraccount .needhelp a{
		display:block;
	}
    .accountdetails .inneraccount .needhelp .callwrite{
      flex-wrap: wrap;
    }
	.account-mobile{
		display:block;
		width: 100%;
		text-align: left;
		margin: 0 0 20px 0;
  }
  .accountdetails .inneraccount .account-mobile{
    margin: 40px 0 0 0;
  }
  .accountdetails .inneraccount .accountboxes{
    margin-top: 20px;
  }
}
</style>